import { MessaggioHome, InfoPagina } from "@hm_app/@core/models/info";
import { HappyMammaService } from "@hm_app/@core/data/happymamma.service";
import { Component, OnInit } from "@angular/core";

import { AuthUser } from "@hm_app/@core/models/auth_user";
import * as _ from "lodash-es";

import { RuoliUtente } from "@hm_app/@core/models/utente";
import { NbAuthService } from "@nebular/auth";
import { AlertModalComponent } from "../alert-modal/alert-modal.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
	selector: "app-dashboard",
	templateUrl: "./dashboard.component.html",
	styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit {
	current_info: InfoPagina;

	iframe_html: any;
	youtube_code: string;

	enum_ruoli = RuoliUtente;
	ruolo: string;

	loading: boolean = false;

	stats: any;

	auth_user: AuthUser;

	async ngOnInit() {
		await this.hmService.refreshUser(true);
		const auth_user = this.hmService.auth_user;
		this.auth_user = auth_user;
		await this.manageRole(auth_user);
		if (this.ruolo == RuoliUtente.ostetrica) {
			this.stats = await this.hmService.getDashboardStats().toPromise();
		}
		this.loading = true;
		let ruoli_dialog: string[] = [
			this.enum_ruoli.ostetrica,
			this.enum_ruoli.medico_generico,
			this.enum_ruoli.medico_generico,
		];
		if (ruoli_dialog.includes(this.ruolo)) {
			var last_opening = localStorage.getItem("lastWelcomeDialogOpening");
			var one_week_ms = 604800000;
			var now = new Date().getTime();
			if (!last_opening || now >= parseInt(last_opening) + one_week_ms) {
				this.openConfirmPopup(
					"Ciao " + auth_user.nome + ",",
					"grazie per contribuire con il tuo lavoro a diffondere l’utilizzo di happymamma e del libretto digitale della gravidanza, strumenti utili per utenti e operatori per semplificare e monitorare il percorso nascita.",
					"Ok",
					null,
					false
				);
				localStorage.setItem(
					"lastWelcomeDialogOpening",
					now.toString()
				);
			}
		}
	}

	openConfirmPopup(
		modalHeader: string,
		modalContent: string,
		modalOkButton: string,
		modalCancelButton: string = null,
		modalCancelEnabled: boolean = true,
		clickOutsideEnabled: boolean = true
	) {
		let backdrop: any;
		if (clickOutsideEnabled) {
			backdrop = true;
		} else {
			backdrop = "static";
		}
		const activeModal = this.modalService.open(AlertModalComponent, {
			size: "md",
			container: "nb-layout",
			backdrop: backdrop,
			modalDialogClass: "welcome-dialog",
		});
		activeModal.componentInstance.modalHeader = modalHeader;
		activeModal.componentInstance.modalContent = modalContent;

		activeModal.componentInstance.modalOkText = modalOkButton;
		if (modalCancelEnabled) {
			activeModal.componentInstance.modalCancelText = modalCancelButton;
			activeModal.componentInstance.modalCancelEnabled =
				modalCancelEnabled;
		}
		activeModal.componentInstance.action.subscribe((okButtonPressed) => {
			if (okButtonPressed) {
				activeModal.componentInstance.action.unsubscribe();
			}
		});
	}

	async manageRole(auth_user) {
		if (auth_user) {
			this.ruolo = auth_user.role;
		} else {
			this.ruolo = null;
		}
		if (this.ruolo != this.enum_ruoli.ostetrica) {
			const tag = document.createElement("script");

			tag.src = "https://www.youtube.com/iframe_api";
			document.body.appendChild(tag);

			let info_pagina = await this.hmService
				.getAll<InfoPagina>(InfoPagina, { pagina: "dashboard_web" })
				.toPromise();
			this.current_info = info_pagina[0];
			this.youtube_code = this.current_info.youtube_code;
		}
	}

	constructor(
		protected hmService: HappyMammaService,
		protected authService: NbAuthService,
		protected modalService: NgbModal
	) {}
}
